import React from 'react'
import dummy from '../images/dummy.jpg'
export default function Inner_Section2() {
  return (
    <>
      <div className="container inner-section2-container">
            <div className="row row-cols-2 row-inner-section2">
                <div className="col side-img-col">
                    <img src={dummy} alt="" />
                </div>
                <div className="col side-img-col">
                <img src={dummy} alt="" />
                </div>
                <div className="col main-col-para ">
                    <div className="sub-main-col-para">
                        <p>
                        Digital Marketing Services that are aligned to your business' growth targets By implementing a strategy-first approach, our team identifies the right approach aligned to 
the goals of your business. This process includes a full competitor audit together with an outline of the messaging, content and services required to achieve your business' growth targets. Our digital marketing strategies are designed to meet the customer where they are at in the buyer's journey and ultimately convert them into loyal 
customers and long standing brand advocates. This is done through smart and personalized digital marketing services, creative thinking and transformative technology, ensuring effective and measurable results.
                        </p>
                        <p>
                        Digital Marketing Services that are aligned to your business' growth targets By implementing a strategy-first approach, our team identifies the right approach aligned to 
the goals of your business. This process includes a full competitor audit together with an outline of the messaging, content and services required to achieve your business' growth targets. Our digital marketing strategies are designed to meet the customer where they are at in the buyer's journey and ultimately convert them into loyal 
customers and long standing brand advocates. This is done through smart and personalized digital marketing services, creative thinking and transformative technology, ensuring effective and measurable results.
                        </p>
                    </div>
                </div>
            </div>
      </div>
    </>
  )
}
